/**
 * Shared helper for stamping owner identity onto quest-spawned agents.
 *
 * Quest runners (loop, ralph, orchestrator) and the queen's handoff MCP server
 * all forward the quest creator's auth-server user-id to every child agent
 * they spawn so the child stays scoped to the same user.
 *
 * Throws when the record has no owner — after the boot-time stamp-legacy-
 * owners migration runs, every persisted quest has a non-null `ownerUserId`,
 * so this should never fire in practice. If it does, fail closed rather
 * than spawn an orphan agent.
 */

import type { QuestRecord } from "./types.js";

export function buildAgentOwnerOptions(record: QuestRecord): {
  ownerUserId: string;
  userId: string;
  username?: string;
} {
  if (!record.ownerUserId) {
    throw new Error(`Quest ${record.id} has no resolved owner — refusing to spawn child agents`);
  }
  return {
    ownerUserId: record.ownerUserId,
    userId: record.ownerUserId,
    ...(record.ownerUsername ? { username: record.ownerUsername } : {}),
  };
}
